module.exports = __webpack_public_path__ + "img/ios-share-to.d09fa9a6.jpg";